import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { AuthService } from '../services/auth-service/auth.service';

@Component({
  selector: 'app-g-authorization-callback',
  templateUrl: './g-authorization-callback.component.html',
  styleUrls: ['./g-authorization-callback.component.css']
})
export class GAuthorizationCallbackComponent implements OnInit {

  constructor(private route:ActivatedRoute,private router:Router,private auth:AuthService) { }

  ngOnInit() {
    let token = this.route.snapshot.queryParams.t;
    this.auth.validateToken(token).then((payload) =>{
      window.localStorage.clear();
      window.localStorage.setItem("login", JSON.stringify({ payload:payload,token:token}));
      this.router.navigate(['/user-portal/account']);
    }).catch(e =>{
      this.router.navigate(['/user/login']);
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/g-authorization-callback/g-authorization-callback.component.ts